import { useState } from 'react';
import PropTypes from 'prop-types';
import hexRgba from 'hex-rgba';
import { color } from '../../../app/theme';

function IconMoveUp16({ className, disabled }) {
  const [isHover, setIsHover] = useState(false);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <circle
        cx="8"
        cy="8"
        r="8"
        fill={disabled || isHover ? hexRgba(color.$10, 40) : color.$10}
      />
      <mask
        id="IconMoveUp16"
        maskUnits="userSpaceOnUse"
        x="4"
        y="3"
        width="8"
        height="10"
      >
        <path
          d="M11.19 7.21a.432.432 0 0 1-.332.143.432.432 0 0 1-.334-.143L8.477 5.163v6.476c0 .286-.191.476-.477.476-.285 0-.476-.19-.476-.476V5.163L5.477 7.21a.46.46 0 0 1-.667 0 .46.46 0 0 1 0-.666l2.857-2.857c.048-.048.095-.096.143-.096.095-.047.238-.047.38 0 .048.048.096.048.144.096l2.857 2.857a.46.46 0 0 1 0 .666z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#IconMoveUp16)">
        <path fill="#fff" d="M1.333 1.333h13.333v13.333H1.333z" />
      </g>
    </svg>
  );
}

IconMoveUp16.defaultProps = {
  className: undefined,
};

IconMoveUp16.propTypes = {
  className: PropTypes.string,
};

export default IconMoveUp16;
